import { Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { CustomvalidationService } from 'src/app/middleware/common/resuableServices/validatorServices';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { OrganizationsService } from '../../services/organizationService/organization.service';
import * as jwt_decode from 'jwt-decode';
import { Subscription } from 'rxjs';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { MatDialog } from '@angular/material/dialog';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { Router } from '@angular/router';
import { RoleLevel } from '../../services/organizationService/organization.enum';
import { ImageCroppedEvent } from 'ngx-image-cropper';
import { Dimensions } from '../lib/interfaces/dimensions.interface';
import { ImageTransform } from '../lib/interfaces/image-transform.interface';
import { MatRadioChange } from '@angular/material/radio';
import {animate, state, style, transition, trigger} from '@angular/animations';

export interface Row {
  mainModuleName: string;
  subModules?: Row[];
}

export const ROWS: Row[] = [
  {
    mainModuleName: "Module 1",
  },
  {
    mainModuleName: "Module 2",
    subModules: [
      {
        mainModuleName: "GK",
      },
    ],
  },
  {
    mainModuleName: "Module 3",
  },
  {
    mainModuleName: "Module 4",
    subModules: [
      {
        mainModuleName: "ILO",
      },
    ],
  },
];


@Component({
  selector: 'app-organization-detail',
  templateUrl: './organization-detail.component.html',
  styleUrls: ['./organization-detail.component.scss'],
   animations: [
      trigger('detailExpand', [
        state('collapsed', style({ height: '0px', minHeight: '0', overflow:'hidden'})),
        state('expanded', style({height: '*'})),
        transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
      ]),
    ],
})
export class OrganizationDetailComponent implements OnInit {
   expanded: {[key: string]: boolean} = {};
  // rows = ROWS;
  public editorConfig = {
    versionCheck: false
  };
  showUserForm: Boolean = false;
  showUserFormOrg: Boolean = false;
  checked: boolean = false;

  @ViewChild('searchCountry') searchCountryclear: ElementRef;
  @ViewChild('searchState') searchStateClear: ElementRef;
  @ViewChild('searchCity') searchCityClear: ElementRef;
  currentUser: any;
  coutryListResponseHolder: any;
  countryList: any[] = [];
  countrySelected: any;
  stateListRResponseHolder: any;
  stateList: any[] = [];
  _stateList: any[] = [];
  stateSelected: any;
  cityListRResponseHolder: any;
  cityList: any[] = [];
  _cityList: any[] = [];
  citySelected: any;
  zipCode: any;
  _countryList: any[] = [];
  addUpdateAddressForm: FormGroup;
  addOfficeSMTPForm: FormGroup;
  addSendGridSMTPForm: FormGroup;
  addUpdateAddressResponseHolder: any;
  activeInactiveResponseHolder: any;
  ResponseHolder: any;
  clickEventsubscription: Subscription;

  isChecked: boolean = false;

  orgDetails: any;
  officeName: string = "";
  domainName: string = "";
  AddedOn: string = "";

  RepresentativeEmail: string = "";
  RepresentativefirstName: string = "";
  RepresentativelastName: string = "";
  RepresentativephoneNumber: string = "";
  SystemModuleList: any = [] = [];
  databaseType: string = "";
  databaseName: string = "";
  RepresentativeformDialog: FormGroup;
  RenameformDialog: FormGroup;
  RenameOrgformDialog: FormGroup;
  myOfficeID: any;
  OfficeAdministratorList: any = [] = [];
  rolesAsssign: any[] = [];
  OrganizationAdmin: boolean = false;
  OfficeAdmin: boolean = false;
  isheadOffice: boolean = false;

  isHeadOffice: boolean = false;
  childOffice: boolean = false;
  SelectedRole: any;
  orgOfficeName: string = "";
  spinner: boolean = false;
  permissionAsssign: any[] = [];
  ActiveInactiveButton: boolean = false;
  ImagePathURL: string = "";
  portalBg: string = "";
  showImports: boolean = false;

  constructor(private formBuilder: FormBuilder, private customValidator: CustomvalidationService,
    private encryptionAlgo: EncryptionService, private reusableClass: ReusableClasses, private statusConst: StatusConstant,
    private loaderService: LoaderService, private toastr: ToastrService, private organizationService: OrganizationsService,
    private dialog: MatDialog, private router: Router) {
    const encryptedtoken = sessionStorage.getItem('userToken');
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.currentUser = jwt_decode(token);
  }

  ngOnInit(): void {
    this.permissionAsssign = JSON.parse(sessionStorage.getItem("menuModules"));
    this.permissionAsssign = this.permissionAsssign.filter((x) => x.mainModuleName == 'Admin' && x.isAssign == true);
    if (this.permissionAsssign.length == 0) {
      this.router.navigate(['unauthorised']);
      return;
    }

    const emailregex: RegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const phoneNumberregex: RegExp = /(\(?[0-9]{3}\)?-?\s?[0-9]{3}-?[0-9]{4})/;


    this.addUpdateAddressForm = this.formBuilder.group({
      address1: ['', Validators.required],
      address2: [''],
      // address2:['', Validators.required],
      countryId: ['', Validators.required],
      stateId: ['', Validators.required],
      cityId: ['', Validators.required],
      postalCode: [''],
    });

    this.addOfficeSMTPForm = this.formBuilder.group({
      displayName: ['', Validators.required],
      emailAddress: ['', [Validators.required, Validators.pattern(emailregex)]],
      smtpserver: ['', Validators.required],
      port: ['', Validators.required],
      userName: ['', Validators.required],
      password: ['', Validators.required],
      ssl: [true, Validators.required],
      testEmail: [''],
    });

    this.addSendGridSMTPForm = this.formBuilder.group({
      displayName: ['', Validators.required],
      emailAddress: ['', [Validators.required, Validators.pattern(emailregex)]],
      apikey: ['', Validators.required],
      testEmail: [''],
    });

    this.RepresentativeformDialog = this.formBuilder.group({
      representativePersonFirstName: ['', Validators.required],
      representativePersonLastName: ['', Validators.required],
      representativePersonphoneNumber: ['', [Validators.pattern(phoneNumberregex)],],
      representativePersonemail: ['', [Validators.required, Validators.pattern(emailregex)]],
    });

    this.RenameformDialog = this.formBuilder.group({
      orgModuleName: ['', Validators.required],
    });

    this.RenameOrgformDialog = this.formBuilder.group({
      officeName: ['', Validators.required],
    });

    this.orgDetails = JSON.parse(sessionStorage.getItem("orgdetail"));
    if (this.orgDetails != null || this.orgDetails != undefined) {
      this.getOfficeDetail();
      // this.getOrgModules();
      //  this.getOfficeAdministratorList();
      if (this.orgDetails.isHeadOffice == true) {
        this.isHeadOffice = true;
        this.childOffice = false;
      }
      if (this.orgDetails.isHeadOffice == false) {
        this.childOffice = true;
        this.isHeadOffice = false;
      }
    }

    if (this.orgDetails.isHeadOffice == true) {
      this.orgOfficeName = "Organization";
    } else {
      this.orgOfficeName = "Office";
    }

    this.rolesAsssign = JSON.parse(sessionStorage.getItem("roles"));
    this.testemail = (sessionStorage.getItem("email"));

    // this.addOfficeSMTPForm.patchValue({
    //   testEmail: this.testemail,                   
    //  });

    if (this.rolesAsssign.length > 0) {
      var role = [];
      // roleLevel:1 (Super admin), roleLevel:2 (Organization Admin), roleLevel:3 (Office Admin),
      // roleLevel:11 (User)
      role = this.rolesAsssign.filter((m) => m.roleLevel == RoleLevel.SuperAdmin);
      if (role.length > 0) {
        this.showImports = true;
        this.ActiveInactiveButton = true;
        return;
      }
      role = this.rolesAsssign.filter((m) => m.roleLevel == RoleLevel.OrganizationAdmin);
      if (role.length > 0) {
        this.showImports = false;
        this.OrganizationAdmin = true;
        this.OfficeAdmin = false;
        this.isheadOffice = this.orgDetails.isHeadOffice;
      }
      role = this.rolesAsssign.filter((m) => m.roleLevel == RoleLevel.OfficeAdmin);
      if (role.length > 0) {
        this.showImports = false;
        this.OrganizationAdmin = false;
        this.OfficeAdmin = true;
      }
    }
  }

  onTabClick(event) {
    if (event.index == 0) {
      this.showSignature = false;
    }
    if (event.index == 1) {
      this.showSignature = false;
      this.getOfficeAdministratorList();
    }
    if (event.index == 2) {
      this.showSignature = false;
      this.getOrgModules();
    }
    if (event.index == 3) {
      this.ShowTestMail = false;
      this.showSignature = true;
      //this.checkedSMTPFlowtrics=false;
      //this.checkedSMTPOffice=false;
      this.getOfficeMailConfigrationDetails();
    }
    if (event.index == 5) {
      this.showSignature = false;
      this.officeIdforImport=0;
      this.userIdforImport="";
      this.adminIdforImport="";    
      this.folderNameForImport="";
      this.getOffices();
      this.getOfficeAdministratorList();
    }
  }



  getOfficeDetail() {
    this.myOfficeID = this.orgDetails.officeID;
    var ReqModel = {
      officeID: this.orgDetails.officeID,
      userID: this.currentUser.UID,
      organizationID: this.orgDetails.organizationID
    }
    this.spinnerLoader = true;
    this.loaderService.show();
    this.organizationService.getOfficeDetail(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.ResponseHolder = response;
        this.spinnerLoader = false;
        this.loaderService.hide();
        if (this.ResponseHolder.status == this.statusConst.statusSuccess) {
          var office = this.ResponseHolder.data.office;
          var organization = this.ResponseHolder.data.organization;
          var representative = this.ResponseHolder.data.representative;
          if (organization != null || organization != undefined) {
            this.domainName = organization.domainName;
            this.AddedOn = organization.createdOn;
            this.isChecked = organization.isActive;
            if (organization.databaseType == 1) {
              this.databaseType = "Shared";
            }
            if (organization.databaseType == 2) {
              this.databaseType = "Dedicated";
            }
            if (organization.databaseType == 3) {
              this.databaseType = "Dedicated Shared";
            }
            this.databaseName = organization.databaseName;;
          }
          if (representative != null || representative != undefined) {
            this.RepresentativeEmail = representative.email;
            this.RepresentativefirstName = representative.firstName;
            this.RepresentativelastName = representative.lastName;
            this.RepresentativephoneNumber = `(${representative.phoneNumber.slice(0, 3)}) ${representative.phoneNumber.slice(3, 6)}-${representative.phoneNumber.slice(6)}`;;
          }
          if (office != null || office != undefined) {
            this.officeName = office.officeName;
            var location = office.location;
            var logo = office.logo;
            var bgLogo = office.portalBg;
            if (location != null || location != undefined) {
              this.countrySelected = location.countryID;
              this.stateSelected = location.stateID;
              this.citySelected = location.cityID;
              this.addUpdateAddressForm.patchValue({
                address1: location.address1,
                address2: location.address2,
                postalCode: location.zipCode,
              });
            }
            if (logo != null || logo != undefined) {
              this.ImagePathURL = logo;
            } else {
              this.ImagePathURL = "";
            }
            if (bgLogo != null || bgLogo != undefined) {
              this.portalBg = bgLogo;
            } else {
              this.portalBg = "";
            }
            if (location.countryID == 0) {
              this.getCountryListDropdownUSA();
            } else {
              this.getCountryListDropdown();
              this.getStateDropdownList();
              this.getCityDropdownList();
            }
          }
          if (office == null || office == undefined) {
            this.getCountryListDropdownUSA();
          }
        }
      }
    });
  }


  getOrgModules() {
    var ReqModel = {
      organizationID: this.orgDetails.organizationID,
      databaseID: this.orgDetails.databaseID,
      officeID: this.orgDetails.officeID,
    }
    this.organizationService.getOrgModules(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.ResponseHolder = response;
        if (this.ResponseHolder.status == this.statusConst.statusSuccess) {
          this.SystemModuleList = this.ResponseHolder.data;
          if(this.SystemModuleList.length>0){
            this.SystemModuleList.forEach(e => {
            e.isDisabled = false;     
            if(e.child==null){
              e.child=[];
            }     
           });
          }      
         if (this.OrganizationAdmin === true && this.isheadOffice === true) {
            this.SystemModuleList.forEach(module => {
            module.isDisabled = true; // Optional: Disable parent if needed
             if (module.child && module.child !== null) {
              module.child.forEach(child => {
              if (child != null) {
                child.isDisabled = true;
               }
              });
             }
            });
         }


          if (this.OfficeAdmin === true) {
           this.SystemModuleList.forEach(module => {
            module.isDisabled = true; // Optional: Disable parent if needed
             if (module.child && module.child !== null) {
              module.child.forEach(child => {
              if (child != null) {
                child.isDisabled = true;
               }
              });
             }
            });
          }


          // if (this.OrganizationAdmin == true && this.isheadOffice == true) {
          //   this.SystemModuleList.forEach(e => {
          //     e.isDisabled = true;
          //   });
          // }
          // if (this.OfficeAdmin == true) {
          //   this.SystemModuleList.forEach(e => {
          //     e.isDisabled = true;
          //   });
          // }
        }
      }
    });
  }

  getOfficeAdministratorList() {
    var ReqModel = {
      organizationID: this.orgDetails.organizationID,
      officeID: this.orgDetails.officeID,
    }
    this.organizationService.getOfficeAdministratorList(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.ResponseHolder = response;
        if (this.ResponseHolder.status == this.statusConst.statusSuccess) {
          this.OfficeAdministratorList = this.ResponseHolder.data;
          this.OfficeAdministratorList.map((res) => {
            if (res.firstName != null) {
              res.firstName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.firstName);
            }
            if (res.lastName != null) {
              res.lastName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.lastName);
            }
            if (res.email != null) {
              res.email = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.email);
            }
            if (res.phoneNumber != null) {
              res.phoneNumber = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.phoneNumber);
            }
            return res;
          });

        }
      }
    });
  }

  getCountryListDropdownUSA() {
    this.organizationService.getCountryList().subscribe((response) => {
      if (response) {
        this.coutryListResponseHolder = response;
        if (this.coutryListResponseHolder.status == this.statusConst.statusSuccess) {
          this.countryList = this.coutryListResponseHolder.data;
          this._countryList = this.coutryListResponseHolder.data;
          var USACountry = [];
          USACountry = this.coutryListResponseHolder.data.filter(x => x.countryName == "United States");
          if (USACountry.length > 0) {
            this.countrySelected = USACountry[0].countryID;
            // this.getStateDropdownListUSA(this.countrySelected);
            this.getStateDropdownList();
          }
        }
      }
    });
  }

  getCountryListDropdown() {
    this.organizationService.getCountryList().subscribe(response => {
      if (response) {
        this.coutryListResponseHolder = response;
        if (this.coutryListResponseHolder.status == this.statusConst.statusSuccess) {
          this.countryList = this.coutryListResponseHolder.data;
          this._countryList = this.coutryListResponseHolder.data;
        }
      }
    });
  }

  getStateDropdownList() {
    this.organizationService.getStateList(this.countrySelected).subscribe(response => {
      if (response) {
        this.stateListRResponseHolder = response;
        if (this.stateListRResponseHolder.status == this.statusConst.statusSuccess) {
          if (this.countrySelected == 231 || this.countrySelected == 38) {
            this.stateListRResponseHolder.data = this.stateListRResponseHolder.data.filter((x) => x.abbreviation != null);

            this.stateList = this.stateListRResponseHolder.data;
            this._stateList = this.stateListRResponseHolder.data;
            this.stateList.forEach(e => {
              e.stateName = e.abbreviation;
            });
            this._stateList.forEach(e => {
              e.stateName = e.abbreviation;
            });
          } else {
            this.stateList = this.stateListRResponseHolder.data;
            this._stateList = this.stateListRResponseHolder.data;
          }
        }
      }
    });
  }


  getCityDropdownList() {
    this.organizationService.getCityList(this.stateSelected).subscribe((response) => {
      if (response) {
        this.cityListRResponseHolder = response;
        if (this.cityListRResponseHolder.status == this.statusConst.statusSuccess) {
          this.cityList = this.cityListRResponseHolder.data;
          this._cityList = this.cityListRResponseHolder.data;
        }
      }
    });
  }

  onChangeCountry(message) {
    const searchInput = message ? message.toLowerCase() : '';
    this.countryList = this._countryList.filter(u => {
      const name: string = u.countryName.toLowerCase();
      return name.indexOf(searchInput) > -1;
    });
  }

  onChangeState(message) {
    const searchInput = message ? message.toLowerCase() : '';
    this.stateList = this._stateList.filter(u => {
      const name: string = u.stateName.toLowerCase();
      return name.indexOf(searchInput) > -1;
    });
  }

  onChangeCity(message) {
    const searchInput = message ? message.toLowerCase() : '';
    this.cityList = this._cityList.filter(u => {
      const name: string = u.cityName.toLowerCase();
      return name.indexOf(searchInput) > -1;
    });
  }

  addUsers(rolelevel) {
    this.SelectedRole = rolelevel;
    this.showUserForm = true;
    this.showUserFormOrg = false;
  }

  addUsersOrg(rolelevel) {
    this.SelectedRole = rolelevel;
    this.showUserForm = false;
    this.showUserFormOrg = true;
  }

  closeSidePanel(event) {
    this.showUserForm = false;
    this.showUserFormOrg = false;
    //this.getOfficeAdministratorList();
  }

  closeSidePanelAfterSave(event) {
    this.showUserForm = false;
    this.showUserFormOrg = false;
    this.getOfficeAdministratorList();
  }

  addUpdateAddress(formValues) {
    this.addUpdateAddressForm.markAsPristine();
    if (formValues != undefined) {
      var ReqModel = {
        officeID: this.orgDetails.officeID,
        organizationID: this.orgDetails.organizationID,
        address: {
          address1: formValues.address1,
          address2: formValues.address2,
          cityID: parseInt(formValues.cityId),
          stateID: parseInt(formValues.stateId),
          countryID: parseInt(formValues.countryId),
          zipCode: formValues.postalCode
        },
        representative: null,
        userID: this.currentUser.UID
      }
      this.organizationService.updateOrganization(ReqModel).subscribe((response) => {
        if (response != undefined) {
          this.addUpdateAddressResponseHolder = response;
          if (this.addUpdateAddressResponseHolder.status == this.statusConst.statusSuccess) {
            this.toastr.success('Address update successfully.', '', {
              timeOut: 3000,
            });
          } else {

          }
        } else {

        }
      });
    }
  }

  // Representative //

  openDialogWithRef(templateRef: TemplateRef<any>) {
    this.RepresentativeformDialog.markAsPristine();
    this.RepresentativeformDialog.patchValue({
      representativePersonFirstName: this.RepresentativefirstName,
      representativePersonLastName: this.RepresentativelastName,
      representativePersonemail: this.RepresentativeEmail,
      representativePersonphoneNumber: this.RepresentativephoneNumber
    });
    this.dialog.open(templateRef, {
    });
  }


  UpdateRepresentativeDetails(formValues) {
    this.spinner = true;
    this.RepresentativeformDialog.markAsPristine();
    if (formValues != undefined) {
      var ReqModel = {
        officeID: this.orgDetails.officeID,
        organizationID: this.orgDetails.organizationID,
        address: null,
        representative: {
          firstName: formValues.representativePersonFirstName,
          lastName: formValues.representativePersonLastName,
          phoneNumber: formValues.representativePersonphoneNumber,
          email: formValues.representativePersonemail
        },
        userID: this.currentUser.UID
      }
      // return;
      this.organizationService.updateOrganization(ReqModel).subscribe((response) => {
        if (response != undefined) {
          this.spinner = false;
          this.addUpdateAddressResponseHolder = response;
          if (this.addUpdateAddressResponseHolder.status == this.statusConst.statusSuccess) {
            this.toastr.success('Representative detail update successfully.', '', {
              timeOut: 3000,
            });
            this.getOfficeDetail();
            this.close();
          } else {
            this.spinner = false;
          }
        } else {
          this.spinner = false;
        }
      });
    }
  }


  close() {
    this.dialog.closeAll();
  }


  // Get Errors for phoneNumber field
  getPhoneErrorMessage() {
    return this.customValidator.getPhoneErrorMessage(this.RepresentativeformDialog);
  }

  getErrorEmail() {
    return this.customValidator.getErrorEmail(this.RepresentativeformDialog);
  }


  // Active or Inactive Module // 

  ActiveOrgModule(event: MatCheckboxChange, mod) {
    var ReqModel = {
      moduleOrgMapID: mod.moduleOrgMapID,
      moduleID: mod.mainModuleID,
      organizationID: this.orgDetails.organizationID,
      officeID: this.orgDetails.officeID,
      orgModuleName: mod.orgModuleName,
      isActive: event.checked,
      userID: this.currentUser.UID
    }
    // return;
    this.organizationService.activeOrgModule(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.addUpdateAddressResponseHolder = response;
        if (this.addUpdateAddressResponseHolder.status == this.statusConst.statusSuccess) {
          this.toastr.success('Detail update successfully.', '', {
            timeOut: 3000,
          });
          this.getOrgModules();
          this.RepresentativeformDialog.markAsPristine();
        } else {

        }
      } else {

      }
    });

  }


  // Rename Org module name //
  moduleOrgMapID: number = 0;
  mainModuleID: number = 0;

  openDialogRenameModuleWithRef(templateRef: TemplateRef<any>, mod) {
    this.RenameformDialog.markAsPristine();
    this.moduleOrgMapID = mod.moduleOrgMapID;
    this.mainModuleID = mod.mainModuleID;
    this.RenameformDialog.patchValue({
      orgModuleName: mod.orgModuleName
    });
    this.dialog.open(templateRef, {
    });
  }

  RenameOrgModule(formValues) {
    this.spinner = true;
    this.RenameformDialog.markAsPristine();
    var ReqModel = {
      moduleOrgMapID: this.moduleOrgMapID,
      moduleID: this.mainModuleID,
      organizationID: this.orgDetails.organizationID,
      officeID: this.orgDetails.officeID,
      orgModuleName: formValues.orgModuleName,
      isActive: true,
      userID: this.currentUser.UID
    }
    this.organizationService.renameOrgModule(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.spinner = false;
        this.addUpdateAddressResponseHolder = response;
        if (this.addUpdateAddressResponseHolder.status == this.statusConst.statusSuccess) {
          this.toastr.success('Module name update successfully.', '', {
            timeOut: 3000,
          });
          this.getOrgModules();
          this.close();
          // this.RenameformDialog.markAsPristine();                          
        } else {
          this.spinner = false;
        }
      } else {
        this.spinner = false;
      }
    });
  }


  // Rename Organization Name //

  openDialogeditOrg(templateRef: TemplateRef<any>) {
    this.RenameOrgformDialog.markAsPristine();
    this.RenameOrgformDialog.patchValue({
      officeName: this.officeName
    });
    this.dialog.open(templateRef, {
    });
  }

  RenameOrganizationName(formValues) {
    this.spinner = true;
    this.RenameOrgformDialog.markAsPristine();
    var ReqModel = {
      officeID: this.orgDetails.officeID,
      organizationID: this.orgDetails.organizationID,
      officeName: formValues.officeName,
      isHeadOffice: this.orgDetails.isHeadOffice,
      userID: this.currentUser.UID
    }
    this.organizationService.renameOrgName(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.spinner = false;
        this.addUpdateAddressResponseHolder = response;
        if (this.addUpdateAddressResponseHolder.status == this.statusConst.statusSuccess) {
          // this.RenameOrgformDialog.markAsPristine();  
          if (this.orgDetails.isHeadOffice == true) {
            this.toastr.success('Organization name update successfully.', '', {
              timeOut: 3000,
            });
          } else {
            this.toastr.success('Office name update successfully.', '', {
              timeOut: 3000,
            });
          }

          this.close();
          this.getOfficeDetail();
        } else {
          this.spinner = false;
        }
      } else {
        this.spinner = false;
      }
    });
  }



  // Org / Office Active/Inactive

  UpdateActiveInactive(event: any) {
    this.loaderService.show();
    var officeID: number = 0;
    var organizationID: number = 0;
    if (this.isHeadOffice == true) {
      officeID = 0;
      organizationID = this.orgDetails.organizationID;
    }
    if (this.isHeadOffice == false) {
      officeID = this.orgDetails.officeID;
      organizationID = 0;
    }
    var ReqModel = {
      isActive: event.checked,
      officeID: officeID,//this.orgDetails.officeID,
      userID: this.currentUser.UID,
      organizationID: organizationID //this.orgDetails.organizationID,
    }
    // return;
    this.organizationService.activeOrg(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.activeInactiveResponseHolder = response;
        if (this.activeInactiveResponseHolder.status == this.statusConst.statusSuccess) {
          var status;
          if (event.checked == true) {
            status = "active";
          } else {
            status = "inactive";
          }
          this.toastr.success(this.officeName + ' ' + status + ' successfully.', '', {
            timeOut: 3000,
          });
          this.getOfficeDetail();
          this.loaderService.hide();
        } else {
          this.loaderService.hide();
        }
      } else {
        this.loaderService.hide();
      }
    });
  }


  /** Allow only Alphabet */
  allowAlphabetOnly(event) {
    const regexp = new RegExp('^[0-9!@#$&()\\-`.+,/\"]*$');
    const result = regexp.test(event.key);
    if (result) {
      //this.titleAlert = 'Please enter only alphabets';
      event.preventDefault();
      return false;
    }
  }

  /** Allow only Number */
  allowOnlyNumber(event) {
    const regexp = new RegExp('^([0-9])$');
    const result = regexp.test(event.key);
    if (!result) {
      event.preventDefault();
      return false;
    }
  }


  imageChangedEvent: any = '';
  croppedImage: any = '';
  FileName: any;
  FileExtention: any;
  responseHolder: any;
  ImageUploadURL: any = '';
  ImageUploadURLforPortal: any = '';
  croppedImageNew: string = "";
  showCropperDiv: boolean = false;


  // @ViewChild('cropper', { static: false })
  cropperDisabled: boolean = false;
  maxWidth: number = 0;
  maxHeight: number = 0;
  maintainAspectRatio: boolean = false;

  imageCropped(event: ImageCroppedEvent) {
    this.maxWidth = event.width;
    this.maxHeight = event.height;
    var check = [];
    check = event.base64.split(',');
    if (check.length > 0) {
      this.croppedImageNew = check[1];
      this.croppedImage = event.base64;
    }
  }

  imageLoaded() {
    // show cropper
  }

  cropperReady() {
    // cropper ready
  }

  cropperReady1(sourceImageDimensions: Dimensions) {
    this.loading = false;
  }

  loadImageFailed() {
    // show message
  }

  cropImage() {
    var reqModel = {
      userID: this.currentUser.UID,
      databaseID: 1,//Number(this.databaseId);
      organizationID: Number(this.orgDetails.organizationID),
      base64String: this.croppedImageNew,
      fileName: this.FileName,
      fileExtention: this.FileExtention,
    }
    this.spinnerLoader = true;
    this.loaderService.show();
    this.organizationService.getImageUlpoadURL(reqModel).subscribe((response) => {
      if (response != undefined) {
        this.spinner = false;
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.ImageUploadURL = response.data;
          if (this.ImageUploadURL != null) {
            this.uploadlogo(this.ImageUploadURL);
            this.croppedImage = "";
            this.spinner = false;
            this.showCropperDiv = false;
            this.InputFile.nativeElement.value = "";
          }
        } else {
          this.spinner = false;
        }
      } else {
        this.spinner = false;
      }
    });
  }

  freeHand() {
    this.maintainAspectRatio = false;
  }


  spinnerLoader: boolean = false;

  uploadlogo(cropimage) {
    var reqModels = {
      userID: this.currentUser.UID,
      databaseID: 1,//Number(this.databaseId);
      organizationID: Number(this.orgDetails.organizationID),
      logo: cropimage,
      officeID: this.orgDetails.officeID,
    }
    this.organizationService.uploadOfficeLogos(reqModels).subscribe((response) => {
      if (response != undefined) {
        this.spinnerLoader = false;
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.getOfficeDetail();
        }
      }
    });
  }


  //   imageChangedEvent: any = '';
  // croppedImage: any = '';
  canvasRotation = 0;
  rotation?: number;
  translateH = 0;
  translateV = 0;
  scale = 1;
  aspectRatio = 1 / 1;
  showCropper = false;
  containWithinAspectRatio = false;
  transform: ImageTransform = {
    translateUnit: 'px',
  };
  imageURL?: string;
  loading = false;
  allowMoveImage = false;
  hidden = false;

  resetImage() {
    this.scale = 1;
    this.rotation = 0;
    this.canvasRotation = 0;
    this.transform = {
      translateUnit: 'px',
    };
  }

  zoomOut() {
    this.scale -= 0.1;
    this.transform = {
      ...this.transform,
      scale: this.scale,
    };
  }

  zoomIn() {
    this.scale += 0.1;
    this.transform = {
      ...this.transform,
      scale: this.scale,
    };
  }

  moveLeft() {
    this.transform = {
      ...this.transform,
      translateH: ++this.translateH,
    };
  }

  moveRight() {
    this.transform = {
      ...this.transform,
      translateH: --this.translateH,
    };
  }

  moveTop() {
    this.transform = {
      ...this.transform,
      translateV: ++this.translateV,
    };
  }

  moveBottom() {
    this.transform = {
      ...this.transform,
      translateV: --this.translateV,
    };
  }


  selectAspectRatio(event: { value: any; }) {
    this.maintainAspectRatio = true;
    if (event.value == "1:1") {
      this.aspectRatio = 1 / 1;
    }
    if (event.value == "1:2") {
      this.aspectRatio = 1 / 2;
    }
    if (event.value == "4:3") {
      this.aspectRatio = 4 / 3;
    }
    if (event.value == "16:9") {
      this.aspectRatio = 16 / 9;
    }
    //this.aspectRatio === 4 / 3 ? 16 / 5 : 4 / 3;
  }

  @ViewChild('Input') InputFile: ElementRef;
  @ViewChild('InputPortal') InputFilePortal: ElementRef;



  /// ====== For SMTP =================//

  msg: string = "";
  showOfficeSMTP: boolean = false;
  showSignature: boolean = false;
  isTested: boolean = false;
  name = 'ng2-ckeditor';
  ckeConfig: any;
  MessageButton: boolean = true;
  showSendGrid: boolean = false;

  ckEditorConfig: any = {
    toolbar: [
      ['Source', 'Templates', 'Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript', '-', 'CopyFormatting', 'RemoveFormat'],
      ['Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo'],
      ['Find', 'Replace', '-', 'SelectAll', '-', 'Scayt'],
      ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote', 'CreateDiv', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock', '-', 'BidiLtr', 'BidiRtl'],
      ['Link', 'Unlink', 'Anchor'],
      ['Image', 'Table', 'HorizontalRule', 'Smiley', 'SpecialChar', 'PageBreak', 'Iframe'],
      ['Styles', 'Format', 'Font', 'FontSize'],
      ['TextColor', 'BGColor'],
      ['Maximize', 'ShowBlocks']
    ]
  };

  CheckMessage(val) {
    if (this.msg != "") {
      this.MessageButton = false;
    } else {
      this.MessageButton = true;
    }
  }

  emailConfigeType: number = 0;

  onSelectSMTP(event: MatRadioChange) {
    this.ShowTestMail = false;

    if (event.value == '1') {
      this.checkedSMTPFlowtrics = true;
      this.checkedSMTPOffice = false;
      this.showOfficeSMTP = false;
      this.showSendGrid = false;
      this.emailConfigeType = 0;
    }
    if (event.value == '2') {
      this.emailConfigeType = 1;
      this.showOfficeSMTP = true;
      this.showSendGrid = false;
      this.getOfficeMailConfigrationDetailsCustomSMTP();
    }
    if (event.value == '3') {
      this.emailConfigeType = 2;
      this.showOfficeSMTP = false;
      this.showSendGrid = true;
      this.getOfficeMailConfigrationDetailsSMTPAPI();
    }
  }

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  addOfficeSMTP(data: any) {
    this.addOfficeSMTPForm.markAsPristine();
    var reqModels = {
      isCustomSMTP: true,
      emailConfigeType: this.emailConfigeType,
      smtpType: 1,
      smtpDetails: {
        displayName: data.displayName,
        email: data.emailAddress,
        smtpServer: data.smtpserver,
        port: data.port,
        userName: data.userName,
        password: data.password,
        useSSL: data.ssl,
        isTested: this.isTested
      },
      userID: this.currentUser.UID,
      organizationID: Number(this.orgDetails.organizationID),
      officeID: this.orgDetails.officeID,
    }
    this.organizationService.addSMTP(reqModels).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.toastr.success('SMTP details added Successfully.', '', {
            timeOut: 3000,
          });
          this.getOfficeMailConfigrationDetails();
        }
      }
    });
  }


  addSMTPAPI(data: any) {
    this.addSendGridSMTPForm.markAsPristine();
    var reqModels = {
      isCustomSMTP: true,
      emailConfigeType: this.emailConfigeType,
      smtpType: 2,
      smtpDetails: {
        displayName: data.displayName,
        email: data.emailAddress,
        apiKey: data.apikey,
        // smtpServer: data.smtpserver,
        // port: data.port,
        // userName: data.userName,
        // password: data.password,
        // useSSL: data.ssl,
        isTested: this.isTested
      },
      userID: this.currentUser.UID,
      organizationID: Number(this.orgDetails.organizationID),
      officeID: this.orgDetails.officeID,
    }
    this.organizationService.addSMTP(reqModels).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.toastr.success('SMTP details added Successfully.', '', {
            timeOut: 3000,
          });
          this.getOfficeMailConfigrationDetails();
        }
      }
    });
  }

  addFlowtricsSMTP() {
    var reqModels = {
      isCustomSMTP: false,
      emailConfigeType: this.emailConfigeType,
      smtpDetails: null,
      userID: this.currentUser.UID,
      organizationID: Number(this.orgDetails.organizationID),
      officeID: this.orgDetails.officeID,
    }
    this.organizationService.addSMTP(reqModels).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.toastr.success('SMTP details added Successfully.', '', {
            timeOut: 3000,
          });
          this.getOfficeMailConfigrationDetails();
        }
      }
    });
  }


  checkedSMTPFlowtrics: boolean = false;
  checkedSMTPOffice: boolean = false;
  checkedSMTPAPIOffice: boolean = false;

  getOfficeMailConfigrationDetails() {
    this.MessageButton = true;
    var reqModels = {
      userID: this.currentUser.UID,
      organizationID: Number(this.orgDetails.organizationID),
      officeID: this.orgDetails.officeID,
    }
    this.organizationService.getOfficeMailConfigration(reqModels).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          if (this.responseHolder.data != null) {
            this.msg = this.responseHolder.data.emailSignature;
            this.emailConfigeType = this.responseHolder.data.eMailConfigeType;
            if (this.emailConfigeType == 0) {
              this.checkedSMTPFlowtrics = true;
              this.checkedSMTPOffice = false;
              this.checkedSMTPAPIOffice = false;

              this.showSendGrid = false;
            }
            if (this.emailConfigeType == 1) {
              this.checkedSMTPFlowtrics = false;
              this.checkedSMTPOffice = true;
              this.checkedSMTPAPIOffice = false;

              this.showOfficeSMTP = true
              this.showSendGrid = false;

              if (this.responseHolder.data.smtpDetails != null) {
                this.addOfficeSMTPForm.patchValue({
                  displayName: this.responseHolder.data.smtpDetails.displayName,
                  emailAddress: this.responseHolder.data.smtpDetails.email,
                  smtpserver: this.responseHolder.data.smtpDetails.smtpServer,
                  port: this.responseHolder.data.smtpDetails.port,
                  userName: this.responseHolder.data.smtpDetails.userName,
                  password: this.responseHolder.data.smtpDetails.password,
                  ssl: this.responseHolder.data.smtpDetails.useSSL,
                  testEmail: this.testemail,
                });
              }
            }
            if (this.emailConfigeType == 2) {
              this.checkedSMTPFlowtrics = false;
              this.checkedSMTPOffice = false;
              this.checkedSMTPAPIOffice = true;

              this.showOfficeSMTP = false;
              this.showSendGrid = true;

              if (this.responseHolder.data.smtpAPI != null) {
                this.addSendGridSMTPForm.patchValue({
                  displayName: this.responseHolder.data.smtpAPI.displayName,
                  emailAddress: this.responseHolder.data.smtpAPI.email,
                  apikey: this.responseHolder.data.smtpAPI.apiKey,
                  // smtpserver: this.responseHolder.data.smtpDetails.smtpServer,
                  // port: this.responseHolder.data.smtpDetails.port,
                  // userName: this.responseHolder.data.smtpDetails.userName,
                  // password: this.responseHolder.data.smtpDetails.password,
                  // ssl: this.responseHolder.data.smtpDetails.useSSL,
                  testEmail: this.testemail,
                });
              }
            }
            // if(this.responseHolder.data.isCustomSMTP==true){
            //  this.checkedSMTPOffice=true;
            //  this.showOfficeSMTP=true;
            //  this.addOfficeSMTPForm.patchValue({
            //   displayName: this.responseHolder.data.smtpDetails.displayName,
            //   emailAddress: this.responseHolder.data.smtpDetails.email,
            //   smtpserver: this.responseHolder.data.smtpDetails.smtpServer,
            //   port: this.responseHolder.data.smtpDetails.port,
            //   userName: this.responseHolder.data.smtpDetails.userName,
            //   password: this.responseHolder.data.smtpDetails.password,
            //   ssl: this.responseHolder.data.smtpDetails.useSSL,
            //   testEmail: this.testemail,               
            //  });
            // }else{
            //   this.checkedSMTPFlowtrics=true;
            //   this.showOfficeSMTP=false;
            // }
          } else {
            this.checkedSMTPFlowtrics = true;
            this.showOfficeSMTP = false;
            this.checkedSMTPAPIOffice = false;
          }
        } else {
          this.checkedSMTPFlowtrics = true;
          this.showOfficeSMTP = false;
          this.checkedSMTPAPIOffice = false;
        }
      } else {
        this.checkedSMTPFlowtrics = true;
        this.showOfficeSMTP = false;
        this.checkedSMTPAPIOffice = false;
      }
    });
  }

  getOfficeMailConfigrationDetailsCustomSMTP() {
    this.MessageButton = true;
    var reqModels = {
      userID: this.currentUser.UID,
      organizationID: Number(this.orgDetails.organizationID),
      officeID: this.orgDetails.officeID,
    }
    this.organizationService.getOfficeMailConfigration(reqModels).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          if (this.responseHolder.data != null) {
            this.msg = this.responseHolder.data.emailSignature;
            if (this.responseHolder.data.smtpDetails != null) {
              this.addOfficeSMTPForm.patchValue({
                displayName: this.responseHolder.data.smtpDetails.displayName,
                emailAddress: this.responseHolder.data.smtpDetails.email,
                smtpserver: this.responseHolder.data.smtpDetails.smtpServer,
                port: this.responseHolder.data.smtpDetails.port,
                userName: this.responseHolder.data.smtpDetails.userName,
                password: this.responseHolder.data.smtpDetails.password,
                ssl: this.responseHolder.data.smtpDetails.useSSL,
                testEmail: this.testemail,
              });
            }

          }
        }
      }
    });
  }

  getOfficeMailConfigrationDetailsSMTPAPI() {
    this.MessageButton = true;
    var reqModels = {
      userID: this.currentUser.UID,
      organizationID: Number(this.orgDetails.organizationID),
      officeID: this.orgDetails.officeID,
    }
    this.organizationService.getOfficeMailConfigration(reqModels).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          if (this.responseHolder.data != null) {
            this.msg = this.responseHolder.data.emailSignature;
            if (this.responseHolder.data.smtpAPI != null) {
              this.addSendGridSMTPForm.patchValue({
                displayName: this.responseHolder.data.smtpAPI.displayName,
                emailAddress: this.responseHolder.data.smtpAPI.email,
                apikey: this.responseHolder.data.smtpAPI.apiKey,
                testEmail: this.testemail,
              });
            }

          }
        }
      }
    });
  }

  testemail: string = "";
  hidenew = true;
  ShowTestMail: boolean = false;

  TestMail(data: any) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    var checkemail = re.test(String(data.testEmail).toLowerCase());
    if (checkemail == true) {
    } else {
      this.toastr.warning('Please provide valid email.', '', {
        timeOut: 3000,
      });
      return;
    }
    this.ShowTestMail = true;
    var reqModels = {
      emailTo: data.testEmail,
      smtpDetails: {
        displayName: data.displayName,
        email: data.emailAddress,
        smtpServer: data.smtpserver,
        port: data.port,
        userName: data.userName,
        password: data.password,
        useSSL: data.ssl,
      }
    }
    this.organizationService.testCustomSMTP(reqModels).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.toastr.success('Test Mail Send Successfully.', '', {
            timeOut: 3000,
          });
        }
      }
    });
  }

  TestMailSendGrid(data: any) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    var checkemail = re.test(String(data.testEmail).toLowerCase());
    if (checkemail == true) {
    } else {
      this.toastr.warning('Please provide valid email.', '', {
        timeOut: 3000,
      });
      return;
    }
    this.ShowTestMail = true;
    var reqModels = {
      emailTo: data.testEmail,
      smtpDetails: {
        displayName: data.displayName,
        email: data.emailAddress,
        apiKey: data.apikey,
        smtpServer: "",
        port: "",
        userName: "",
        password: "",
        //useSSL: data.ssl,
      }
    }
    this.organizationService.testSmtpAPI(reqModels).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.toastr.success('Test Mail Send Successfully.', '', {
            timeOut: 3000,
          });
        }
      }
    });
  }

  showContent(templateRef: TemplateRef<any>) {
    this.dialog.open(templateRef, {
    });
  }

  addEmailSignature() {
    var reqModels = {
      emailSignature: this.msg,
      userID: this.currentUser.UID,
      organizationID: Number(this.orgDetails.organizationID),
      officeID: this.orgDetails.officeID,
    }
    this.MessageButton = true;
    this.spinnerLoader = true;
    this.organizationService.addEmailSignature(reqModels).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.spinnerLoader = false;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.toastr.success('ESignature added Successfully.', '', {
            timeOut: 3000,
          });
        } else {
          this.spinnerLoader = false;
        }
      } else {
        this.spinnerLoader = false;
      }
    });
  }

  IsTested(tested) {
    this.addOfficeSMTPForm.markAsDirty();
    if (tested == true) {
      this.isTested = true;
    } else {
      this.isTested = false;
    }
  }

  IsTestedAPI(tested) {
    this.addSendGridSMTPForm.markAsDirty();
    if (tested == true) {
      this.isTested = true;
    } else {
      this.isTested = false;
    }
  }

  fileChangeEvent(event: any): void {
    var file = event.target.files[0];
    var pattern = /image-*/;
    var reader = new FileReader();
    if (!file.type.match(pattern)) {
      this.toastr.warning('accept only image/jpg format.', '', {
        timeOut: 3000,
      });
      return;
    }
    var filename = event.target.files[0].name;
    var test = filename.split('.');
    this.FileName = test[0];
    this.FileExtention = '.' + test[1];
    this.imageChangedEvent = event;
    this.showCropperDiv = true;
    // this.handleInputChange(event.target.files[0]);
  }



  //=================For Upload Image Background =================//

  imageSrc: string = "";
  width: number = 0;
  height: number = 0;

  fileChangeEventForPortal(event: any): void {
    var file = event.target.files[0];
    var pattern = /image-*/;
    var reader = new FileReader();
    if (!file.type.match(pattern)) {
      this.toastr.warning('Please upload image exclusively in PNG or JPG/JPEG formats.', '', {
        timeOut: 3000,
      });
      return;
    }
    var filename = event.target.files[0].name;
    var test = filename.split('.');
    this.FileName = test[0];
    this.FileExtention = '.' + test[1];
    const URL = window.URL || window.webkitURL;
    const Img = new Image();

    const filesToUpload = (event.target.files);
    Img.src = URL.createObjectURL(filesToUpload[0]);

    Img.onload = (e: any) => {
      this.height = e.srcElement.naturalHeight;
      this.width = e.srcElement.naturalWidth;

    }
    this.handleInputChange(event.target.files[0]);

  }

  handleInputChange(files) {
    var file = files;
    var pattern = /image-*/;
    var reader = new FileReader();
    if (!file.type.match(pattern)) {
      alert('invalid format');
      return;
    }
    this.FileName = reader.onloadend = this._handleReaderLoaded.bind(this);
    reader.readAsDataURL(file);
  }

  _handleReaderLoaded(e) {
    let reader = e.target;
    var base64result = reader.result.substr(reader.result.indexOf(',') + 1);
    this.imageSrc = base64result;
    var obj = {
      userID: this.currentUser.UID,
      databaseID: 1,//Number(this.databaseId);
      organizationID: Number(this.orgDetails.organizationID),
      officeID: this.orgDetails.officeID,
      base64String: this.imageSrc,
      fileName: this.FileName,
      fileExtention: this.FileExtention,
    }
    this.organizationService.getImageUlpoadURL(obj).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.ImageUploadURLforPortal = response.data;
        }
      }
    });
  }

  uploadBackgroundImage() {
    if (this.width <= 1280 && this.height <= 768) {
      this.toastr.warning('Please upload Image with minimum dimensions 1024x768 (Width x Height).', '', {
        timeOut: 3000,
      });
      this.ImageUploadURLforPortal = "";
      return;
    }
    var obj = {
      imagePath: this.ImageUploadURLforPortal,
      userID: this.currentUser.UID,
      organizationID: Number(this.orgDetails.organizationID),
      officeID: this.orgDetails.officeID,
    }
    this.spinnerLoader = true;
    this.organizationService.uploadPortalbackgroundImage(obj).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.spinnerLoader = false;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.ImageUploadURLforPortal = "";
          this.toastr.success('Image upload successfully.', '', {
            timeOut: 3000,
          });
          this.getOfficeDetail();
        } else {
          this.spinnerLoader = false;
        }
      } else {
        this.spinnerLoader = false;
      }
    });
  }


  //======== For Import Forms ===============//

  OfficeListforImport: any = [] = [];
  officeIdforImport: number = 0;
  adminIdforImport: string="";
  folderNameForImport:string="";
  SelectedOfficeUser:any=[]=[];
  userIdforImport: string="";

  getOffices() {
    var ReqModel = {
      officeID: 0,
      userID: this.currentUser.UID,
      organizationID: 1,
      databaseId: 0
    }
    this.spinnerLoader = true;
    this.loaderService.show();
    this.organizationService.getOffices(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.ResponseHolder = response;
        this.spinnerLoader = false;
        this.loaderService.hide();
        if (this.ResponseHolder.status == this.statusConst.statusSuccess) {
          this.OfficeListforImport = this.ResponseHolder.data.organizations[0].offices;
        } else {
          this.OfficeListforImport = [];
        }
      } else {
        this.OfficeListforImport = [];
      }
    });
  }

  OnSelectOfficeforImport(officeId) {
    this.officeIdforImport = officeId.value;
    this.userIdforImport="";
    this.SelectedOfficeUser=[]; 
    var ReqModel = {
      organizationID: 1,//this.orgDetails.organizationID,
      officeID: Number(officeId.value)//this.orgDetails.officeID,
    }
    this.organizationService.getOfficeAdministratorList(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.ResponseHolder = response;
        if (this.ResponseHolder.status == this.statusConst.statusSuccess) {
          this.SelectedOfficeUser = this.ResponseHolder.data;
          this.SelectedOfficeUser.map((res) => {
            if (res.firstName != null) {
              res.firstName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.firstName);
            }
            if (res.lastName != null) {
              res.lastName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.lastName);
            }
            if (res.email != null) {
              res.email = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.email);
            }
            if (res.phoneNumber != null) {
              res.phoneNumber = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.phoneNumber);
            }
            return res;
          });

        }
      }
    });
  }

 

  OnSelectAdminforImport(officeId) {
    this.adminIdforImport = officeId.value;
  }

  OnSelectUseraccountImport(officeId) {
    this.userIdforImport = officeId.value;
  }

  importForms() {   
    if(this.officeIdforImport==0){
      this.toastr.warning('Please select office', '', {
        timeOut: 3000,
      });  
      return;
    }
    if(this.userIdforImport==""){
      this.toastr.warning('Please select user account of super admins office', '', {
        timeOut: 3000,
      });  
      return;
    }
    if(this.adminIdforImport==""){
      this.toastr.warning('Please select admin user', '', {
        timeOut: 3000,
      });  
      return;
    }
    var ReqModel = {
      formID: 0,
      rootFolderName: this.folderNameForImport,
      importFromUserID: this.userIdforImport,//this.currentUser.UID,
      importFromOfficeID: Number(this.officeIdforImport),
      importFromOrganizationID: 1,
      userID: this.adminIdforImport,//,//this.adminIdforImport,
      organizationID: Number(this.orgDetails.organizationID),
      officeID: this.orgDetails.officeID,
      databaseID: 0    
    }
    this.spinnerLoader = true;
    this.organizationService.importFormsfromAOffice(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.spinnerLoader = false;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {         
          this.toastr.success('Form imported successfully.', '', {
            timeOut: 3000,
          });     
          this.officeIdforImport=0;    
          this.adminIdforImport="";
          this.folderNameForImport="";
          this.userIdforImport="";
          this.getOffices();
          this.getOfficeAdministratorList();
        } else {
          this.spinnerLoader = false;
        }
      } else {
        this.spinnerLoader = false;
      }
    });
  }


  importFileManagerFolder() {   
    if(this.officeIdforImport==0){
      this.toastr.warning('Please select office', '', {
        timeOut: 3000,
      });  
      return;
    }
    if(this.userIdforImport==""){
      this.toastr.warning('Please select user account of super admins office', '', {
        timeOut: 3000,
      });  
      return;
    }
    if(this.adminIdforImport==""){
      this.toastr.warning('Please select admin user', '', {
        timeOut: 3000,
      });  
      return;
    }
    var ReqModel = {
      copyUserID:this.adminIdforImport, //this.userIdforImport,
      originUserID: this.userIdforImport,//this.adminIdforImport,
      originOfficeID: Number(this.officeIdforImport),
      originOrgID:1,
      copyOfficeID:this.orgDetails.officeID,
      copyOrgID: Number(this.orgDetails.organizationID),   
    }
    this.spinnerLoader = true;
    this.organizationService.importFileManagerFoldersFromAOffice(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.spinnerLoader = false;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {   
          this.toastr.success('File Manager Folders imported successfully.', '', {
            timeOut: 3000,
          });     
          this.officeIdforImport=0;    
          this.adminIdforImport="";
          this.folderNameForImport="";
          this.userIdforImport="";
          this.getOffices();
          this.getOfficeAdministratorList();
        } else {
          this.spinnerLoader = false;
        }
      } else {
        this.spinnerLoader = false;
      }
    });
  }

  importAIQuestion() {   
    if(this.officeIdforImport==0){
      this.toastr.warning('Please select office', '', {
        timeOut: 3000,
      });  
      return;
    }
    if(this.userIdforImport==""){
      this.toastr.warning('Please select user account of super admins office', '', {
        timeOut: 3000,
      });  
      return;
    }
    if(this.adminIdforImport==""){
      this.toastr.warning('Please select admin user', '', {
        timeOut: 3000,
      });  
      return;
    }
    var ReqModel = {
      originUserID: this.userIdforImport,//this.adminIdforImport,
      originOfficeID: Number(this.officeIdforImport),
      originOrgID:1,
      copyUserID:this.adminIdforImport, //this.userIdforImport,     
      copyOfficeID:this.orgDetails.officeID,
      copyOrgID: Number(this.orgDetails.organizationID),   
    }
    this.spinnerLoader = true;
    this.organizationService.importQuestionTemplatesFromAOffice(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.spinnerLoader = false;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {   
          this.toastr.success('AI Question imported successfully.', '', {
            timeOut: 3000,
          });     
          this.officeIdforImport=0;    
          this.adminIdforImport="";
          this.folderNameForImport="";
          this.userIdforImport="";
          this.getOffices();
          this.getOfficeAdministratorList();
        } else {
          this.spinnerLoader = false;
        }
      } else {
        this.spinnerLoader = false;
      }
    });
  }

  importAIFieldTemplates() {   
    if(this.officeIdforImport==0){
      this.toastr.warning('Please select office', '', {
        timeOut: 3000,
      });  
      return;
    }
    if(this.userIdforImport==""){
      this.toastr.warning('Please select user account of super admins office', '', {
        timeOut: 3000,
      });  
      return;
    }
    if(this.adminIdforImport==""){
      this.toastr.warning('Please select admin user', '', {
        timeOut: 3000,
      });  
      return;
    }
    var ReqModel = {
      originUserID: this.userIdforImport,//this.adminIdforImport,
      originOfficeID: Number(this.officeIdforImport),
      originOrgID:1,
      copyUserID:this.adminIdforImport, //this.userIdforImport,     
      copyOfficeID:this.orgDetails.officeID,
      copyOrgID: Number(this.orgDetails.organizationID),   
    }
    this.spinnerLoader = true;
    this.organizationService.importFieldTemplatesFromAOffice(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.spinnerLoader = false;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {   
          this.toastr.success('AI Field Templates imported successfully.', '', {
            timeOut: 3000,
          });     
          this.officeIdforImport=0;    
          this.adminIdforImport="";
          this.folderNameForImport="";
          this.userIdforImport="";
          this.getOffices();
          this.getOfficeAdministratorList();
        } else {
          this.spinnerLoader = false;
        }
      } else {
        this.spinnerLoader = false;
      }
    });
  }

  importAIAutomationTemplates() {   
    if(this.officeIdforImport==0){
      this.toastr.warning('Please select office', '', {
        timeOut: 3000,
      });  
      return;
    }
    if(this.userIdforImport==""){
      this.toastr.warning('Please select user account of super admins office', '', {
        timeOut: 3000,
      });  
      return;
    }
    if(this.adminIdforImport==""){
      this.toastr.warning('Please select admin user', '', {
        timeOut: 3000,
      });  
      return;
    }
    var ReqModel = {
      originUserID: this.userIdforImport,//this.adminIdforImport,
      originOfficeID: Number(this.officeIdforImport),
      originOrgID:1,
      copyUserID:this.adminIdforImport, //this.userIdforImport,     
      copyOfficeID:this.orgDetails.officeID,
      copyOrgID: Number(this.orgDetails.organizationID),   
    }
    this.spinnerLoader = true;
    this.organizationService.importAIAutomationTemplateFromAOffice(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.spinnerLoader = false;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {   
          this.toastr.success('AI Automation Templates imported successfully.', '', {
            timeOut: 3000,
          });     
          this.officeIdforImport=0;    
          this.adminIdforImport="";
          this.folderNameForImport="";
          this.userIdforImport="";
          this.getOffices();
          this.getOfficeAdministratorList();
        } else {
          this.spinnerLoader = false;
        }
      } else {
        this.spinnerLoader = false;
      }
    });
  }


  expandedModules: Record<string, boolean> = {};

toggleExpand(moduleName: string): void {
  this.expandedModules[moduleName] = !this.expandedModules[moduleName];
}

 isRowClickable(rowIndex: number) {
   // this.indexExpanded = rowIndex;
    return this.SystemModuleList[rowIndex].child && this.SystemModuleList[rowIndex].child.length > 0;
  }

}
